(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cust_benefit-box-content"] && !Shopify.designMode) return;
  try {
    
  function initTooltip() {
    const tooltip = document.querySelectorAll('[data-js-tooltip]');
    const tooltipMobile = document.querySelectorAll('[data-js-tooltip-mobile]');
    let tooltipVisible = false; // Flag to track tooltip visibility

    if (tooltip || tooltipMobile) {
      // Use click event for mobile
      tooltipMobile.forEach(function(tooltip) {
        tooltip.addEventListener('click', function() {
          console.log('click');
          const content = tooltip.closest('[data-js-tooltip-container]').querySelector('[data-js-tooltip-content]');
          tooltipVisible = !tooltipVisible; // Toggle the flag
          content.classList.toggle('cust-benefit-box-content__info-box--visible', tooltipVisible);

          // Add event listener for click the box
          content.addEventListener('click', function() {
            tooltipVisible = false; // Reset the flag
            content.classList.remove('cust-benefit-box-content__info-box--visible');
          });
        });
      });

      // Use mouseover/mouseout for desktop
      tooltip.forEach(function(tooltip) {
        tooltip.addEventListener('mouseover', function() {
          console.log('mouseover');
          const content = tooltip.closest('[data-js-tooltip-container]').querySelector('[data-js-tooltip-content]');
          content.classList.add('cust-benefit-box-content__info-box--visible');
        });
        tooltip.addEventListener('mouseout', function() {
          console.log('mouseout');
          const content = tooltip.closest('[data-js-tooltip-container]').querySelector('[data-js-tooltip-content]');
          content.classList.remove('cust-benefit-box-content__info-box--visible');
        });
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function() {
    // Initialize the tooltip
    initTooltip();

    // Add event listener for window resize
    window.addEventListener("resize", function() {
      // Re-initialize the tooltip on resize
      initTooltip();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_faq-with-image"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const items = document.querySelectorAll('[data-item]');
    items.forEach(item => {
      item.addEventListener('click', function() {
        this.classList.toggle('active');
        items.forEach(otherItem => {
          if (otherItem !== this) {
            otherItem.classList.remove('active');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m11-bf-grid-section"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(){
        const btn = document.querySelector('.m11-bf-grid__btn');
        const wrapper = document.querySelector('.m11-bf-grid__popup');
        const closeIcon = document.querySelector('.m11-bf-grid__popup .close-icon');
        btn.addEventListener('click', function(){
            wrapper.style.display = 'block';
        });
        closeIcon.addEventListener('click', function(){
            wrapper.style.display = 'none';
        });
        window.addEventListener('click', function(e){
            if(e.target === wrapper && e.target != document.querySelector('.m9-icon-with-popup-inner')){
                wrapper.style.display = 'none';
            }
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-compare-table-new"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        if(document.querySelector('.pdp-compare-table-block-subscribe-popup-button')){
            const popupButton = document.querySelector('.pdp-compare-table-block-subscribe-popup-button');
            const popupButtonWrapper = document.querySelector('.pdp-subscribe-popup-container');
            const popupCloseButton = document.querySelector('.pdp-subscribe-popup-close-button');

            popupButton.addEventListener('click', function() {
                popupButtonWrapper.style.display = 'block';
                document.body.classList.add('overflow-hidden');
            });

            popupCloseButton.addEventListener('click', function() {
                popupButtonWrapper.style.display = 'none';
                document.body.classList.remove('overflow-hidden');
            });

            popupButtonWrapper.addEventListener('click', function(e) {
                if(!e.target.classList.contains('pdp-subscribe-popup-content') && !e.target.closest('.pdp-subscribe-popup-content')){
                popupButtonWrapper.style.display = 'none';
                document.body.classList.remove('overflow-hidden');
                }
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-specs-new"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.pdp-specs-new__tab-title');
    const contents = document.querySelectorAll('.pdp-specs-new__tab-content');
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', function() {
        // Hide all contents
        contents.forEach(content => content.classList.remove('active'));
        // Show the corresponding content
        contents[index].classList.add('active');

        // Remove active class from all tabs
        tabs.forEach(tab => tab.classList.remove('active'));
        // Set the clicked tab as active
        tab.classList.add('active');

        let elLeft = tab.offsetLeft;
        let elParent = tab.parentElement;
        let elParentLeft = elParent.offsetLeft;
        let window_width = window.innerWidth / 2;
        // check if element not in view
        if (elLeft > window_width) {
          elParent.parentElement.scrollLeft = elLeft - elParentLeft - window_width + (tab.offsetWidth / 2);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-video-12v"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        (function() {
            // Only initialize if we have video containers with posters
            if (!document.querySelector('.video-container__poster')) {
                return;
            }

            // Store players in a map using container ID as key
            const players = new Map();

            document.querySelectorAll('.video-container__poster').forEach(poster => {
            poster.addEventListener('click', function(e) {
                const container = poster.closest('.video-container__wrapper');
                const videoElement = container.querySelector('[data-video-id]');
                const ytID = videoElement.getAttribute('data-video-id');
                const embed = container.querySelector('.video-container__embed');
                const containerId = container.getAttribute('id');

                playVideo(embed, ytID, containerId, poster);
                poster.style.display = 'none';
                embed.style.display = 'block';

            });
            });

            // Load YouTube IFrame API (only once)
            if (!window.YT) {
                var tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            }

            function playVideo(embed, ytID, containerId, poster) {
                if (!embed) {
                    return;
                }

                // First clear any existing content
                embed.innerHTML = '';

                // Create a new container for the video
                const videoContainer = document.createElement('div');
                videoContainer.className = 'video-container__embed-video';
                embed.appendChild(videoContainer);

                const player = new YT.Player(videoContainer, {
                    videoId: ytID,
                    playerVars: {
                    'playsinline': 1
                    },
                    events: {
                    'onReady': onPlayerReady,
                    'onStateChange': (event) => onPlayerStateChange(event, embed, poster)
                    }
                });

                // Store player reference
                players.set(containerId, player);
            }

            function onPlayerReady(event) {
                event.target.playVideo();
            }

            function onPlayerStateChange(event, embed, poster) {
                // YT.PlayerState.ENDED = 0
                if (event.data === 0) {
                    // Video ended - show poster and hide embed
                    poster.style.display = 'block';
                    embed.style.display = 'none';
                    // Rewind video to beginning
                    event.target.seekTo(0);
                }
            }

            // Clean up players when section is unloaded
            document.addEventListener('shopify:section:unload', function(event) {
                const container = event.target;
                const containerId = container.getAttribute('id');

                if (players.has(containerId)) {
                    const player = players.get(containerId);
                    player.destroy();
                    players.delete(containerId);
                }
            });
        })();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-button"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const popupButton = document.querySelector('.popup-button-link');
    const popupButtonWrapper = document.querySelector('.popup-button-wrapper');
    const popupCloseButton = document.querySelector('.popup-close-button');

    popupButton.addEventListener('click', function() {
      popupButtonWrapper.style.display = 'block';
      document.body.classList.add('overflow-hidden');
    });

    popupCloseButton.addEventListener('click', function() {
      popupButtonWrapper.style.display = 'none';
      document.body.classList.remove('overflow-hidden');
    });

    popupButtonWrapper.addEventListener('click', function(e) {
      if(!e.target.classList.contains('popup-button-popup-content') && !e.target.closest('.popup-button-popup-content')){
        popupButtonWrapper.style.display = 'none';
        document.body.classList.remove('overflow-hidden');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-page-product-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelectorAll('.star-products-container.swiper');
    section.forEach(section => {
        const swiper = new Swiper(section, {
            slidesPerView: section.getAttribute('data-per-row-m'),
            spaceBetween: 12,
            navigation: {
                nextEl: section.querySelector('.swiper-button-next'),
                prevEl: section.querySelector('.swiper-button-prev'),
            },
            scrollbar: {
                el: section.querySelector('.swiper-scrollbar'),
            },
            breakpoints: {
                749: {
                    slidesPerView: section.getAttribute('data-per-row'),
                    spaceBetween: 24,
                },
            },
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-page-title"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sectionRoot = document.querySelector('.star-page-title-section');

    if (!sectionRoot) {
      return;
    }

    var sectionWrapper = sectionRoot.parentElement;
    const popupButton = sectionRoot.querySelector('.popup-button-link');
    const popupButtonWrapper = sectionWrapper ? sectionWrapper.querySelector('.popup-button-wrapper') : null;
    const popupCloseButton = popupButtonWrapper ? popupButtonWrapper.querySelector('.popup-close-button') : null;

    const handlePopupOpen = function() {
      popupButtonWrapper.style.display = 'block';
      document.body.classList.add('overflow-hidden');
    };

    const handlePopupClose = function() {
      popupButtonWrapper.style.display = 'none';
      document.body.classList.remove('overflow-hidden');
    };

    const handlePopupWrapperClick = function(e) {
      if (!e.target.classList.contains('popup-button-popup-content') && !e.target.closest('.popup-button-popup-content')) {
        handlePopupClose();
      }
    };

    if (popupButton && popupButtonWrapper && popupCloseButton) {
      popupButton.addEventListener('click', handlePopupOpen);
      popupCloseButton.addEventListener('click', handlePopupClose);
      popupButtonWrapper.addEventListener('click', handlePopupWrapperClick);
    }

    document.querySelectorAll('[data-pw-free-ecoflow-client-check="1"]').forEach(function (root) {
      var hasSession = (function () {
        if (typeof getCookie !== 'function') return false;
        var raw = getCookie('userInfo');
        if (!raw) return false;
        try {
          var parsed = JSON.parse(decodeURIComponent(raw));
          return !!(parsed && parsed.token && String(parsed.token).length > 0);
        } catch (e) { return false; }
      })();

      if (hasSession) {
        root.querySelectorAll('[data-open-password-free-login-popup]').forEach(function (btn) {
          var msg = btn.getAttribute('data-password-free-success-message');
          if (msg && msg.trim()) {
            btn.textContent = msg.trim();
            btn.classList.add('password-free-button-link--logged-in');
          }
          btn.removeAttribute('data-open-password-free-login-popup');
        });
      }
    });

    document.addEventListener('shopify:section:unload', function() {
      if (popupButton && popupButtonWrapper && popupCloseButton) {
        popupButton.removeEventListener('click', handlePopupOpen);
        popupCloseButton.removeEventListener('click', handlePopupClose);
        popupButtonWrapper.removeEventListener('click', handlePopupWrapperClick);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
